import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {useHistory} from 'react-router-dom';
import {Button} from 'primereact/button';
import {CSSTransition} from 'react-transition-group';
import {I18n} from "react-redux-i18n";
import {Dropdown} from "primereact/dropdown";
import {useSelector} from "react-redux";
import BusinessService from "./services/BusinessService";
import {useDispatch} from 'react-redux';
import {
    setCurrentBusinessAction,
    setBusinessListAction,
    setBusinessProductionAction,
    clearCurrentBusinessAction
} from "./actions/business";
import ManageBusiness from "./components/ManageBusiness";

const AppTopbarDefault = (props) => {

    const dispatch = useDispatch();
    const isRTL = false;
    const history = useHistory();
    const businessStateList = useSelector(state => state.business.list);
    const [businessList, setBusinessList] = useState([]);
    const [business, setBusiness] = useState(null);
    const businessService = new BusinessService();
    const [elementDialog, setElementDialog] = useState(false);
    const [businessType, setBusinessType] = useState(null);
    const [businessTypes, setBusinessTypes] = useState([]);

    const manageBusiness = (business) => {
        if (business!=null) {
            setBusiness(business);
            const selected = getBusinessTypes().find(opt => opt.value === business.live);
            setBusinessType(selected)
            dispatch(setBusinessProductionAction(business.live));
            if (business.live === false) {
                const typesList = getBusinessTypes().filter(item => item.value === false);
                setBusinessTypes(typesList)
            } else {
                setBusinessTypes(getBusinessTypes());
            }
        }else {
            setBusiness({
                identifier: "all",
                name: I18n.t('ALL_BUSINESS')
            });
            const selected = getBusinessTypes().find(opt => opt.value === false);
            setBusinessType(selected)
            dispatch(setBusinessProductionAction(false));
            setBusinessTypes(getBusinessTypes());
        }
    }

    useEffect(() => {
        const loadBusiness = async () => {
            try {
                setBusinessTypes(getBusinessTypes());
                const response = await businessService.getAll();
                const content = response?.data?.content || [];
                dispatch(setBusinessListAction(content));
                if (content.length === 1) {
                    const business = content.pop()
                    manageBusiness(business);
                    dispatch(setCurrentBusinessAction(business));
                }
            } catch (error) {
                console.error('Failed to load operators', error);
            }
        };
        loadBusiness();
        // eslint-disable-next-line
    }, [props.locale]);

    useEffect(() => {
        const list = businessStateList.map(business => ({
            label: business.name,
            value: business.identifier,
            url: business.logo?.url,
        }));
        const allBusiness = {
            label: I18n.t('ALL_BUSINESS'),
            value: "all"
        }
        list.push(allBusiness);
        setBusinessList(list);
        if (business) {
            const upBusiness = businessStateList.find(b => b.identifier === business.identifier);
            manageBusiness(upBusiness);
        }
    },// eslint-disable-next-line
        [businessStateList, props.locale]);


    function onBusinessChange(e) {
        let identifier = e.target.value;
        if(identifier=== "all") {
            manageBusiness(null);
            dispatch(clearCurrentBusinessAction(business));
        }else {
            const business = businessStateList.find(business => business.identifier === identifier);
            manageBusiness(business);
            dispatch(setCurrentBusinessAction(business));
        }
    }

    function getBusinessTypes() {
        const typesList = [];
        typesList.push({label: I18n.t('SANDBOX_MODE'), value: false, icon: 'pi pi-trash', color: '#6c757d'});
        typesList.push({label: I18n.t('PRODUCTION_MODE'), value: true, icon: 'pi pi-globe', color: '#28a745'});
        return typesList;
    }

    function onBusinessTypeChange(e) {
        const selected = businessTypes.find(opt => opt.value === e.target.value);
        setBusinessType(selected)
        dispatch(setBusinessProductionAction(selected.value));
    }

    let localeButton;
    if (props.locale === 'fr-FR') {
        if (!props.loadingLang) {
            localeButton = <button type="button" className="layout-topbar-action p-link"
                                   onClick={e => props.handleLanguageLinkClick(e, "en-US")}>
                <img src="assets/demo/flags/flag_placeholder.png" alt='English'
                     className="primeface-flag primeface-flag-uk" width={30} height={20}/>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">English</span>
            </button>
        } else {
            localeButton = <Button label="Loading" iconPos="right" loading/>
        }
    } else {
        if (!props.loadingLang) {
            localeButton = <button type="button" className="layout-topbar-action p-link"
                                   onClick={e => props.handleLanguageLinkClick(e, "fr-FR")}>
                <img src="assets/demo/flags/flag_placeholder.png" alt='Français'
                     className="primeface-flag primeface-flag-fr" width={30} height={20}/>
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">Français</span>
            </button>
        } else {
            localeButton = <Button label="Chargement en cours" iconPos="right" loading/>
        }
    }

    function onComplete(res) {
        let element = res.data;
        if (element === null) {
            setElementDialog(false);
        } else {
            businessStateList.unshift(element);
            dispatch(setBusinessListAction(businessStateList));
            setElementDialog(false);
        }
    }

    return (
        <div className="layout-topbar p-shadow-4">
            <div className="layout-topbar-left">
                <button type="button" style={{cursor: 'pointer'}} className="layout-topbar-logo p-link"
                        onClick={() => history.push('/')}>
                    <img id="app-logo" src="assets/layout/images/logo.png" alt="Payvalis"
                         style={{height: '2.25rem'}}/>
                </button>
                <button type="button" className="layout-menu-button p-shadow-6 p-link"
                        onClick={props.onMenuButtonClick}>
                    <i className="pi pi-chevron-right"></i>
                </button>
                <button type="button" className="layout-topbar-mobile-button p-link">
                    <i className="pi pi-ellipsis-v fs-large" onClick={props.onMobileTopbarButtonClick}></i>
                </button>
            </div>

            <div
                className={classNames('layout-topbar-right', {'layout-topbar-mobile-active': props.mobileTopbarActive})}>
                <div className="layout-topbar-actions-left">
                    <div className="layout-topbar-actions-right">
                        <ul className="layout-topbar-items">
                            <li className="layout-topbar-item">
                                <Dropdown style={{ marginLeft: '7px', backgroundColor: 'inherit'}}
                                          className="app-top-bar-dropdown"
                                          value={business?.identifier}
                                          onChange={onBusinessChange}
                                          options={businessList}
                                          placeholder={I18n.t('SELECT_BUSINESS')}
                                          itemTemplate={(option) => (
                                              <div style={{display: 'flex', alignItems: 'center'}}>
                                                  {option.url && <img
                                                      src={option.url}
                                                      alt={option.label}
                                                      style={{height: 20, marginRight: 10, borderRadius: '50%'}}
                                                  />}
                                                  <span style={{ textTransform: 'uppercase' }}>{option.label}</span>
                                              </div>
                                          )}
                                          valueTemplate={(selectedValue, props) => {
                                              if (!business) return props.placeholder;
                                              return (
                                                  <div style={{display: 'flex', alignItems: 'center'}}>
                                                      {business.logo && <img
                                                          src={business.logo?.url}
                                                          alt={business.name}
                                                          style={{height: 20, marginRight: 10, borderRadius: '50%', backgroundColor: 'white'}}
                                                      />}
                                                      <span style={{ textTransform: 'uppercase' }}>{business.name}</span>
                                                  </div>
                                              );
                                          }}
                                />
                            </li>
                            <li className="layout-topbar-item">
                                <Dropdown
                                    style={{ marginLeft: '7px' ,backgroundColor: 'inherit'}}
                                    className="app-top-bar-dropdown"
                                    value={businessType?.value}
                                    onChange={onBusinessTypeChange}
                                    options={businessTypes}
                                    optionLabel="label"
                                    placeholder={I18n.t('SELECT_MODE')}
                                    itemTemplate={(option) => (
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <i className={option.icon}
                                               style={{marginRight: 10, color: option.color}}/>
                                            <span style={{color: option.color}}>{option.label}</span>
                                        </div>
                                    )}
                                    valueTemplate={(value, props) => {
                                        if (!businessType) return props.placeholder;
                                        return (
                                            <div className="p-d-flex p-ai-center">
                                                <i className={businessType.icon}
                                                   style={{marginRight: 10}}/>
                                                <span>{businessType.label}</span>
                                            </div>
                                        );
                                    }}
                                />

                            </li>

                            <li className="layout-topbar-item">
                                <button className="layout-topbar-action rounded-circle p-link"
                                        onClick={() => setElementDialog(true)}>
                                    <i className="pi pi-plus-circle fs-xlarge"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="layout-topbar-actions-right">
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item">
                            <button className="layout-topbar-action rounded-circle p-link"
                                    onClick={(event) => props.onTopbarItemClick({
                                        originalEvent: event,
                                        item: 'notifications'
                                    })}>
                                <i className="pi pi-refresh fs-large"></i>
                            </button>
                        </li>
                        <li className="layout-topbar-item">
                            {localeButton}
                        </li>
                        <li className="layout-topbar-item notifications">
                            <button className="layout-topbar-action rounded-circle p-link"
                                    onClick={(event) => props.onTopbarItemClick({
                                        originalEvent: event,
                                        item: 'notifications'
                                    })}>
                                <span className="p-overlay-badge">
                                    <i className="pi pi-bell fs-large"></i>
                                    <span className="p-badge p-badge-warning p-badge-dot"></span>
                                </span>
                            </button>

                            <CSSTransition classNames="p-toggleable" timeout={{enter: 1000, exit: 450}}
                                           in={props.activeTopbarItem === 'notifications'} unmountOnExit>
                                <ul className="layout-topbar-action-panel p-shadow-6 fadeInDown">
                                    <li className="p-mb-3">
                                        <span className="p-px-3 fs-small">You have <b>4</b> new notifications</span>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="p-d-flex p-flex-row p-ai-center">
                                            <img src="assets/demo/images/avatar/avatar-1.png" alt=""/>
                                            <div className={classNames('p-d-flex p-flex-column', {
                                                'p-ml-3': !isRTL,
                                                'p-mr-3': isRTL
                                            })} style={{flexGrow: '1'}}>
                                                <div className="p-d-flex p-ai-center p-jc-between p-mb-1">
                                                    <span className="fs-small p-text-bold">Jerome Bell</span>
                                                    <small>42 mins ago</small>
                                                </div>
                                                <span
                                                    className="fs-small">How to write content about your photographs?</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="p-d-flex p-flex-row p-ai-center">
                                            <img src="assets/demo/images/avatar/avatar-2.png" alt=""/>
                                            <div className={classNames('p-d-flex p-flex-column', {
                                                'p-ml-3': !isRTL,
                                                'p-mr-3': isRTL
                                            })} style={{flexGrow: '1'}}>
                                                <div className="p-d-flex p-ai-center p-jc-between p-mb-1">
                                                    <span className="fs-small p-text-bold">Cameron Williamson</span>
                                                    <small>48 mins ago</small>
                                                </div>
                                                <span
                                                    className="fs-small">Start a blog to reach your creative peak.</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="p-d-flex p-flex-row p-ai-center">
                                            <img src="assets/demo/images/avatar/avatar-3.png" alt=""/>
                                            <div className={classNames('p-d-flex p-flex-column', {
                                                'p-ml-3': !isRTL,
                                                'p-mr-3': isRTL
                                            })} style={{flexGrow: '1'}}>
                                                <div className="p-d-flex p-ai-center p-jc-between p-mb-1">
                                                    <span className="fs-small p-text-bold">Anna Miles</span>
                                                    <small>1 day ago</small>
                                                </div>
                                                <span className="fs-small">Caring is the new marketing</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="p-d-flex p-flex-row p-ai-center">
                                            <img src="assets/demo/images/avatar/avatar-4.png" alt=""/>
                                            <div className={classNames('p-d-flex p-flex-column', {
                                                'p-ml-3': !isRTL,
                                                'p-mr-3': isRTL
                                            })} style={{flexGrow: '1'}}>
                                                <div className="p-d-flex p-ai-center p-jc-between p-mb-1">
                                                    <span className="fs-small p-text-bold">Arlene Mccoy</span>
                                                    <small>4 day ago</small>
                                                </div>
                                                <span
                                                    className="fs-small">Starting your traveling blog with Vasco.</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </CSSTransition>
                        </li>
                        <li className="layout-topbar-item app">
                            <button className="layout-topbar-action rounded-circle p-link"
                                    onClick={(event) => props.onTopbarItemClick({
                                        originalEvent: event,
                                        item: 'apps'
                                    })}>
                                <i className="pi pi-table fs-large"></i>
                            </button>

                            <CSSTransition classNames="p-toggleable" timeout={{enter: 1000, exit: 450}}
                                           in={props.activeTopbarItem === 'apps'} unmountOnExit>
                                <div className="layout-topbar-action-panel p-shadow-6">
                                    <div className="p-grid p-nogutter">
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-flex-column text-color p-link">
                                                <i className="pi pi-image action indigo-bgcolor white-color"></i>
                                                <span>Products</span>
                                            </button>
                                        </div>
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-flex-column text-color p-link">
                                                <i className="pi pi-file-pdf action orange-bgcolor white-color"></i>
                                                <span>Reports</span>
                                            </button>
                                        </div>
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-flex-column text-color p-link">
                                                <i className="pi pi-dollar action teal-bgcolor white-color"></i>
                                                <span>Balance</span>
                                            </button>
                                        </div>
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-flex-column text-color p-link">
                                                <i className="pi pi-cog action pink-bgcolor white-color"></i>
                                                <span>Settings</span>
                                            </button>
                                        </div>
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-flex-column text-color p-link">
                                                <i className="pi pi-key action bluegrey-bgcolor white-color"></i>
                                                <span>Credentials</span>
                                            </button>
                                        </div>
                                        <div className="layout-topbar-action-item p-col-4">
                                            <button
                                                className="p-d-flex p-ai-center p-jc-center p-flex-column text-color p-link">
                                                <i className="pi pi-sitemap action cyan-bgcolor white-color"></i>
                                                <span>Sitemap</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </CSSTransition>
                        </li>
                    </ul>
                </div>
            </div>

            <ManageBusiness show={elementDialog} onComplete={onComplete}/>
        </div>
    );

}

export default AppTopbarDefault;
